/* @flow */
import React from 'react';

import cx from 'classnames';
import { isSupportedType } from 'lib/ImageSupport';

import styles from './styles/Image.css';

/**
 * Basic image component with a few options
 */

export default class Image extends React.Component {
  static propTypes = {
    /** URL of the image to display */
    src: React.PropTypes.string.isRequired,
    /** Round the edges of the image */
    circle: React.PropTypes.bool,
    /**
     * Accessible text for screenreaders. Defaults to an empty string so that screenreaders don't
     * read the URL of the image.
     */
    alt: React.PropTypes.string,
    disableUserInteraction: React.PropTypes.bool,
    onLoad: React.PropTypes.func,
    height: React.PropTypes.number,
    width: React.PropTypes.number,
    style: React.PropTypes.object,
    srcSet: React.PropTypes.string,
  };


  static defaultProps = {
    circle: false,
    alt: '',
    onLoad: () => {},
    draggable: true,
  };

  static isSupportedType = isSupportedType;

  render() {
    return (
      <img
        onLoad={this.props.onLoad}
        alt={this.props.alt}
        src={this.props.src}
        height={this.props.height}
        width={this.props.width}
        draggable={!this.props.disableUserInteraction}
        style={this.props.style}
        srcSet={this.props.srcSet}
        className={cx({
          [styles.interactionDisabled]: this.props.disableUserInteraction,
          [styles.circle]: this.props.circle,
        }, this.props.className)}
        // Setting the key on images is a fix for Safari not rendering SVGs
        // correctly when you change their src. This way is the src changes, it
        // makes a new img element and Safari renders it correctly.
        key={this.props.src}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Image.jsx